import React from "react";
import "./App.css";
import mapboxgl from "mapbox-gl";
import { readRemoteFile } from "react-papaparse";
import InputRange from "react-input-range";
import data from "./data/uber-raw-data-sep14.csv";
mapboxgl.accessToken =
  "pk.eyJ1IjoicmFpY2h1ciIsImEiOiJCX2J1Uk1jIn0.Dss8lGxgTYKK1jDusc4lJw";

let map;
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lng: -73.9646,
      lat: 40.7474,
      zoom: 11,
      hourVal: 12,
      allResults: [],
      firstLoad: true,
      // Filter by weekday, saturday, or sunday
      filterDay: {
        all: true,
        weekday: false,
        saturday: false,
        sunday: false,
      },
      currentWeekFilter: "all",
    };
  }
  componentDidMount() {
    // Instantiate map
    map = new mapboxgl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/raichur/ckc4bxnxz0jda1ko8h6n6htgl",
      center: [this.state.lng, this.state.lat],
      zoom: this.state.zoom,
    });

    // Get CSV file
    readRemoteFile(data, {
      complete: (results) => {
        results.data.shift();
        console.log(results.data);
        this.setState({ allResults: results }); // Set results here so only do this once
        var curThis = this;
        map.on("load", function () {
          curThis.getResults(); // After map loads, get the results of the time filter from data
        });
      },
    });
  }

  // Time filter from data
  getResults() {
    var curLocations = [];
    this.state.allResults.data.map((result) => {
      if (this.state.currentWeekFilter === "all") {
        if (result[0].split(":")[0] === String(this.state.hourVal)) {
          curLocations.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [result[3], result[2]],
            },
            properties: {
              title: result[0],
            },
          });
          return curLocations;
        }
      } else if (this.state.currentWeekFilter === "weekday") {
        if (
          result[0].split(":")[0] === String(this.state.hourVal) &&
          result[1].split("/")[1] !==
            String(6 || 7 || 13 || 14 || 20 || 21 || 27 || 28)
        ) {
          curLocations.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [result[3], result[2]],
            },
            properties: {
              title: result[0],
            },
          });
          return curLocations;
        }
      } else if (this.state.currentWeekFilter === "saturday") {
        if (
          result[0].split(":")[0] === String(this.state.hourVal) &&
          result[1].split("/")[1] === String(6 || 13 || 20 || 27)
        ) {
          curLocations.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [result[3], result[2]],
            },
            properties: {
              title: result[0],
            },
          });
          return curLocations;
        }
      } else if (this.state.currentWeekFilter === "sunday") {
        if (
          result[0].split(":")[0] === String(this.state.hourVal) &&
          result[1].split("/")[1] === String(7 || 14 || 21 || 28)
        ) {
          curLocations.push({
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [result[3], result[2]],
            },
            properties: {
              title: result[0],
            },
          });
          return curLocations;
        }
      }
    });

    if (this.state.firstLoad) {
      // Check if it's the first load to decide whether to add source or update it
      map.addSource("points", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: curLocations,
        },
      });
      map.addLayer({
        id: "points",
        source: "points",
        type: "heatmap",
        maxzoom: 15,
        // Paint settings
        paint: {
          "heatmap-intensity": {
            stops: [
              [11, 1],
              [15, 3],
            ],
          },
          "heatmap-color": [
            "interpolate",
            ["linear"],
            ["heatmap-density"],
            0,
            "rgba(236,222,239,0)",
            0.2,
            "rgb(208,209,230)",
            0.4,
            "rgb(166,189,219)",
            0.6,
            "rgb(103,169,207)",
            0.8,
            "rgb(28,144,153)",
          ],
          "heatmap-radius": {
            stops: [
              [11, 15],
              [15, 20],
            ],
          },
          "heatmap-opacity": {
            default: 1,
            stops: [
              [14, 1],
              [15, 0],
            ],
          },
        },
      });
      this.setState({ firstLoad: false });
    } else {
      // Source already there, update it
      if (curLocations.length) {
        map.getSource("points").setData({
          type: "FeatureCollection",
          features: curLocations,
        });
      }
    }
  }

  // Handle the change of the slider
  handleSliderChange(e) {
    this.setState({ hourVal: e }); // Set hour value
    this.getResults(); // Filter data based on hour value!
  }

  handleWeekFilterChange(e) {
    if (e.currentTarget.dataset.active === "false") {
      var curFilters = this.state.filterDay;
      for (var value of Object.entries(curFilters)) {
        curFilters[value[0]] = false;
      }
      curFilters[e.currentTarget.dataset.id] = true;
      this.setState({ filterDay: curFilters });
    }
    this.setState({ currentWeekFilter: e.currentTarget.dataset.id }, () => {this.getResults()});
  }

  render() {
    return (
      <>
        <div className="top">
          <h2>
            {this.state.hourVal}:00, <span>{this.state.currentWeekFilter}</span>
          </h2>
          {/* Slider input */}
          <InputRange
            maxValue={23}
            minValue={0}
            step={1}
            value={this.state.hourVal}
            onChange={(value) => this.setState({ hourVal: value })}
            onChangeComplete={this.handleSliderChange.bind(this)}
          />
          {/* Week input */}
          <ul className="weekList">
            {Object.keys(this.state.filterDay).map((el, index) => (
              <li
                key={index}
                data-id={el}
                data-active={this.state.filterDay[el]}
                onClick={this.handleWeekFilterChange.bind(this)}
              >
                {el}
              </li>
            ))}
          </ul>
        </div>
        <div ref={(el) => (this.mapContainer = el)} className="mapContainer" />
      </>
    );
  }
  ˇ;
}

export default App;
